module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.wrapClasses,
    style: (_vm.styles)
  }, [_c('div', {
    class: [_vm.prefixCls + '-tail']
  }, [_c('i')]), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-head']
  }, [_c('div', {
    class: [_vm.prefixCls + '-head-inner']
  }, [(!_vm.icon && _vm.currentStatus != 'finish' && _vm.currentStatus != 'error') ? _c('span', [_vm._v(_vm._s(_vm.stepNumber))]) : _c('span', {
    class: _vm.iconClasses
  })])]), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-main']
  }, [_c('div', {
    class: [_vm.prefixCls + '-title']
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default", [(_vm.content) ? _c('div', {
    class: [_vm.prefixCls + '-content']
  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59dd8c30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/steps/step.vue
// module id = 635
// module chunks = 1